import { colorsPalettes } from "@similarweb/styles";

import { type ILegendProps, useHeatMapContext } from "./heatmap.shared";
import { LegendCell, LegendContainer } from "./HeatMap.styles";

const DEFAULT_MIN_LABEL = <span>Less</span>;
const DEFAULT_MAX_LABEL = <span>More</span>;

const HeatMapLegend = ({ minLabel, maxLabel }: ILegendProps) => {
    const { colorScale } = useHeatMapContext();
    const resolvedMinLabel = minLabel ?? DEFAULT_MIN_LABEL;
    const resolvedMaxLabel = maxLabel ?? DEFAULT_MAX_LABEL;

    return (
        <LegendContainer
            fontVariant="listItem3"
            color={colorsPalettes.carbon[400]}
        >
            {resolvedMinLabel}
            {colorScale.colors.map((color) => (
                <LegendCell
                    key={color}
                    $color={color}
                />
            ))}
            {resolvedMaxLabel}
        </LegendContainer>
    );
};

export { HeatMapLegend };
